import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wix': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M393.4 131.7c0 13 2.1 32.7-28.7 43.8-9.5 3.5-16 9.7-16 9.7 0-31 4.7-42.2 17.4-48.9 9.8-5.1 27.2-4.6 27.2-4.6zM277.6 167.2c5.5-26.3 30.9-38.3 55.3-35.3l-65.6 247.9s-21.6 1.6-32.5-4c-14.2-7.3-21-12.8-29.6-46.6-7.7-30.1-29.1-118.4-31.1-124.7-4.3-13.8-10.6-14.9-15.4 0-2 6.3-23.5 94.6-31.1 124.7-8.6 33.7-15.4 39.3-29.6 46.6-10.8 5.5-32.5 4-32.5 4l-65.6-247.9c23.9-3 49.7 8.5 55.3 35.3l34.2 132.7 28.5-108.6c7.8-32.4 21.1-48.5 48.4-48.5 27.6 0 40.7 16.5 48.4 48.5l28.5 108.6zM393.4 172.4v9l0 0v150.3c-0.1 30.8-3.3 37.7-17.3 44.8-10.8 5.5-27.4 3.4-27.4 3.4v-152.1c0-21.3-2-27.9 13.2-35.2 6.2-3 12-5.3 18-8.6 9.4-5.2 13.5-11.6 13.5-11.6zM556.8 256.5l83 123.4s-35.9 4.6-53.3-11.2c-13.9-12.7-23.7-28.3-53.1-70.7-0.5-0.8-6.3-10.5-13.1 0-34.9 50.3-41 60.3-52.5 70.7-17.4 15.8-54 11.2-54 11.2l83-123.4-83.2-123.7s35.1-6 52.5 9.8c13.4 12.2 24.9 30.2 54.2 72.5 6.8 10.5 12.6 0.7 13.1 0 29.8-42.9 40.9-60.4 54.2-72.5 17.4-15.8 52.5-9.8 52.5-9.8z'
      }
    ]
  }
})
